// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4dca65d02fc1f64848bb","655":"efc70d589bfc72bb2e98"}[chunkId] + ".js";
};